import { api } from "./index";

export interface VendorCategory {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  subcategories: VendorSubcategory[];
}

export interface VendorSubcategory {
  id: string;
  categoryId: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  category?: VendorCategory;
}

export interface VendorCategoryMapping {
  id: string;
  subcategoryId: string;
  subcategoryName: string;
  categoryId: string;
  categoryName: string;
  createdAt: string;
}

export interface CreateCategoryDto {
  name: string;
  description?: string;
}

export interface UpdateCategoryDto {
  name?: string;
  description?: string;
}

export interface CreateSubcategoryDto {
  name: string;
  description?: string;
}

export interface UpdateSubcategoryDto {
  name?: string;
  description?: string;
}

export interface UpdateVendorCategoriesDto {
  subcategoryIds: string[];
}

export const vendorCategoriesApi = {
  // Admin endpoints
  listCategories: (): Promise<VendorCategory[]> =>
    api.get("/vendors/categories").then((res) => res.data),

  getCategory: (id: string): Promise<VendorCategory> =>
    api.get(`/vendors/categories/${id}`).then((res) => res.data),

  createCategory: (data: CreateCategoryDto): Promise<{ category: VendorCategory; message: string }> =>
    api.post("/vendors/categories", data).then((res) => res.data),

  updateCategory: (id: string, data: UpdateCategoryDto): Promise<{ category: VendorCategory; message: string }> =>
    api.patch(`/vendors/categories/${id}`, data).then((res) => res.data),

  deleteCategory: (id: string): Promise<{ message: string }> =>
    api.delete(`/vendors/categories/${id}`).then((res) => res.data),

  createSubcategory: (categoryId: string, data: CreateSubcategoryDto): Promise<{ subcategory: VendorSubcategory; message: string }> =>
    api.post(`/vendors/categories/${categoryId}/subcategories`, data).then((res) => res.data),

  updateSubcategory: (id: string, data: UpdateSubcategoryDto): Promise<{ subcategory: VendorSubcategory; message: string }> =>
    api.patch(`/vendors/subcategories/${id}`, data).then((res) => res.data),

  deleteSubcategory: (id: string): Promise<{ message: string }> =>
    api.delete(`/vendors/subcategories/${id}`).then((res) => res.data),

  // Vendor endpoints
  getAvailableCategories: (): Promise<VendorCategory[]> =>
    api.get("/vendors/categories/available", { useVendorAuth: true }).then((res) => res.data),

  getVendorCategories: (): Promise<VendorCategoryMapping[]> =>
    api.get("/vendors/profile/categories", { useVendorAuth: true }).then((res) => res.data),

  updateVendorCategories: (data: UpdateVendorCategoriesDto): Promise<{ categories: VendorCategoryMapping[]; message: string }> =>
    api.put("/vendors/profile/categories", data, { useVendorAuth: true }).then((res) => res.data),
};

